import { stringValidator } from '#validation/common/validators';
import { FILESPACE_NAME_CONTENT_REGEX, FILESPACE_NAME_END_REGEX, FILESPACE_NAME_MAX_LENGTH, FILESPACE_NAME_MIN_LENGTH, FILESPACE_NAME_OPENAPI_REGEX, FILESPACE_NAME_START_REGEX, } from '../constants';
export const filespaceNameValidator = stringValidator({
    requiredError: 'filespace.name.required',
    minLength: {
        min: FILESPACE_NAME_MIN_LENGTH,
        error: 'filespace.name.minLength',
    },
    maxLength: {
        max: FILESPACE_NAME_MAX_LENGTH,
        error: 'filespace.name.maxLength',
    },
    formats: [
        {
            regex: FILESPACE_NAME_START_REGEX,
            error: 'filespace.name.startChar',
        },
        {
            regex: FILESPACE_NAME_END_REGEX,
            error: 'filespace.name.endChar',
        },
        {
            regex: FILESPACE_NAME_CONTENT_REGEX,
            error: 'filespace.name.invalidChar',
        },
    ],
    openApiFormat: FILESPACE_NAME_OPENAPI_REGEX,
});
